import { palette } from '@livable/saas-react-components';
import { makeStyles } from '@mui/styles';
const useStyles = makeStyles({
  unitsList: {
    borderRadius: '2px',
    border: "1px solid ".concat(palette.shades[300])
  }
});
export default useStyles;